const ManagementAccounts = () => {
  return (
    <p>
      These could be whatever your business uses to aid forecasting, spending
      and budgeting.
    </p>
  );
};

export default ManagementAccounts;
